import { z } from 'zod';
import { CoreNotifyAnonymousContactMethodTypeSchema } from '../inputTypeSchemas/CoreNotifyAnonymousContactMethodTypeSchema'
import { CoreNotifyAnonymousContactSourceTypeSchema } from '../inputTypeSchemas/CoreNotifyAnonymousContactSourceTypeSchema'

/////////////////////////////////////////
// CORE NOTIFY ANONYMOUS CONTACT SCHEMA
/////////////////////////////////////////

export const CoreNotifyAnonymousContactSchema = z.object({
  phoneNumberInvitationMethod: CoreNotifyAnonymousContactMethodTypeSchema.nullable(),
  phoneNumberVerificationMethod: CoreNotifyAnonymousContactMethodTypeSchema.nullable(),
  phoneNumberSource: CoreNotifyAnonymousContactSourceTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  phoneNumber: z.string(),
  phoneNumberOptedInAt: z.coerce.date().nullable(),
  phoneNumberOptedOutAt: z.coerce.date().nullable(),
  phoneNumberInvitedAt: z.coerce.date().nullable(),
  phoneNumberSMSCapable: z.boolean(),
})

export type CoreNotifyAnonymousContact = z.infer<typeof CoreNotifyAnonymousContactSchema>

export default CoreNotifyAnonymousContactSchema;
